module.exports = __webpack_public_path__ + "static/media/preplay-up-arrow-white.ef535f2a.webp";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/preplay-up-arrow-white.webp
// module id = ./src/assets/images/preplay-up-arrow-white.webp
// module chunks = 0